import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import {
  MAX_CONTENT_HEIGHT,
  MAX_MOBILE_CONTENT_HEIGHT,
  TABS_HEAIGHT,
} from '../../../styles/constants';

const topSpaceHeight = '8px';

export const useStyles = makeStyles<Theme>()((theme) => ({
  trainingViewContent: {
    maxHeight: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${topSpaceHeight})`,
    height: `calc(${MAX_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${topSpaceHeight})`,
    overflowY: 'auto',
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      maxHeight: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${topSpaceHeight})`,
      height: `calc(${MAX_MOBILE_CONTENT_HEIGHT} - ${TABS_HEAIGHT} - ${topSpaceHeight})`,
    },
  },
}));
